module.exports = __webpack_public_path__ + "img/gatorz-grid-item.8be4c931.webp";